export const hebrewTranslations = {
    // Dialog titles and buttons
    "salesPromotionsPermissions": "הגדרת הרשאות קד\"מ ודוגמיות",
    "editData": "ערוך נתונים",
    "defineData": "הגדר נתונים",
    "cancel": "ביטול",
    "save": "שמור",

    // Field labels
    "branch": "סניף",
    "ordererCustomer": "לקוח מזמין",
    "intOrderType": "סוג הזמנה פנימי",
    "extOrderType": "סוג הזמנה חיצוני",
    "family": "משפחות מוצר",
    "receiveCustomer": "לקוחות מקבלים",
    "salesPromotionsAndSamples": "קד\"מ ודוגמיות",

    // Validation messages
    "selectBranch": "יש לבחור סניף",
    "selectOrderingCustomer": "יש לבחור לקוח מזמין אחד לפחות",
    "selectProductFamily": "יש לבחור משפחת מוצר אחת לפחות",

    // Success/Error messages
    "updateSuccess": "הרשאות קד\"מ ודוגמיות עודכנו בהצלחה",
    "updateError": "ארעה שגיאה בעדכון הרשאות קד\"מ ודוגמיות",

    // Selection indicators
    "itemsSelected": "נבחרו",
    "itemSelected": "נבחר",
    "noneSelected": "לא נבחר",
    "noOptions": "אין אפשרויות זמינות"
};